import * as React from "react";
import { forwardRef } from "react";
const SvgBack = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 25, viewBox: "0 0 10 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.85355 5L9.56066 5.70711L2.41421 12.8536L9.56066 20L8.85356 20.7071L1 12.8536L8.85355 5Z", fill: "black" }));
const ForwardRef = forwardRef(SvgBack);
export { ForwardRef as ReactComponent };
